import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { useAuth } from "./providers/AuthProvider";
import Collection from "./components/views/Collection";
import CreateCollection from "./components/views/CreateCollection";
import Login from "./components/views/Login";
import Register from "./components/views/Register";
import ProtectedRoute from './components/ProtectedRoute';
import Home from "./components/views/Home";

const Router = () => {
  const { currentUser } = useAuth();

  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path='/' element={currentUser ? <Home /> : <Login />} />
        <Route path='/register' element={
          <ProtectedRoute requireAuth={false}>
            <Register />
          </ProtectedRoute>
        } />
        <Route path='/collection/:collectionId' element={
          <ProtectedRoute>
            <Collection />
          </ProtectedRoute>
        } />
        <Route path='/new-collection' element={
          <ProtectedRoute>
            <CreateCollection />
          </ProtectedRoute>
        } />
      </Routes>
    </Suspense>
  );
};

export default Router;
